export default __webpack_public_path__ + "static/dave-vetter-transblue-2c4ee7940e76a5059114b9c27e6293bb.png";